import type { CompanyInfo, CompanyPortalSectionKey } from '@/interfaces/company';
import type { TenantModule } from '@/interfaces/tenants';
import { httpService } from '@/services/utils/http_service';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useCompanyStore = defineStore('company', () => {

    const company = ref<CompanyInfo>();

    const nickname = ref('');

    const isSuperAdmin = computed(() => company.value?.bl_super_admin ?? false)

    const hasModule = (module: TenantModule) => {
        return company.value?.ar_modulos_ativos?.includes(module) ?? false
    }

    const withNickname = (url: string) => {
        return nickname.value ? `${url}?vc_apelido=${nickname.value}` : url;
    }

    const logo = computed(() => {
        return withNickname(httpService.getUrl(`/public/company/logo`))
    })

    const logoExpanded = computed(() => {
        return withNickname(httpService.getUrl(`/public/company/logo-expanded`))
    })

    const background = computed(() => {
        return withNickname(httpService.getUrl(`/public/company/background`))
    })

    const video = computed(() => {
        return withNickname(httpService.getUrl(`/public/company/video-login`))
    })

    // Portal
    const portalLogo = computed(() => {
        return withNickname(httpService.getUrl(`/public/company/portal/logo`))
    })

    const portalLoginLogo = computed(() => {
        return withNickname(httpService.getUrl(`/public/company/portal/login-logo`))
    })

    const portalLoginBackground = computed(() => {
        return withNickname(httpService.getUrl(`/public/company/portal/login-background`))
    })

    const portalCover = computed(() => {
        return withNickname(httpService.getUrl(`/public/company/portal/cover`))
    })

    const portalGallery = computed(() => {
        return httpService.getUrl(`/public/company/portal/gallery`)
    })

    const portalGalleryUrl = (path: string) => {
        const query = nickname.value ? `path=${path}&vc_apelido=${nickname.value}` : `path=${path}`;
        return `${portalGallery.value}?${query}`;
    }

    const portalSessionsOrder = computed((): CompanyPortalSectionKey[] => {
        return ([
            'theme',
            'login',
            'header',
            'cover',
            'jobsList'
        ] as CompanyPortalSectionKey[]).concat(((company.value?.portalConfig?.order) ?? []) as CompanyPortalSectionKey[]);
    })

    return {
        company,
        nickname,
        isSuperAdmin,
        hasModule,
        logo,
        logoExpanded,
        background,
        video,
        portalLogo,
        portalLoginLogo,
        portalLoginBackground,
        portalCover,
        portalGallery,
        portalGalleryUrl,
        portalSessionsOrder
    }

});
